import React from 'react';
import './SlideShow.css'
import Slider from "react-slick";
// import { CradleLoader } from "react-loader-spinner";
import Card from '../Card/Card';
// var settings = {
//     dots: true,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     initialSlide: 0,
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 3,
//                 slidesToScroll: 3,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 2,
//                 initialSlide: 2
//             }
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             }
//         }
//     ]
// };

var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

const SlideShow = ({ slideShowData }) => {
    return (
        <div className="container slider-block" id='Slider'>
            <h1 className='text-center slider-products'>Products</h1>
            <div className="row">
                <div>
                    <Slider {...settings}>
                        {
                            slideShowData?.length > 0 ? slideShowData?.map((item, index) => (
                                <div className="col-sm-3" key={index}>
                                    <Card item={item} type={item.category} />
                                </div>
                            ))
                                :
                                <div className='text-center'>
                                    {/* <CradleLoader ariaLabel="loading-indicator" /> */}
                                    </div>
                        }
                    </Slider>
                </div>
                {/* <Slider {...settings}>
                    
                </Slider> */}
            </div>
        </div>
    );
};

export default SlideShow;